import React from 'react';
import PropTypes from 'prop-types';

const langs = ['ru', 'en'];

class EditableText extends React.PureComponent {
  constructor(...props) {
    super(...props);

    this.setEditing = this.setEditing.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onLangChange = this.onLangChange.bind(this);
    this.save = this.save.bind(this);

    const value = this.props.value ? this.props.value : '';
    this.state = {
      editing: false,
      currentValue: value === Object(value) ? value['ru'] : value,
      currentLang: 'ru',
    };
  }

  componentWillReceiveProps(newProps) {
    const newValue = newProps.noLang
      ? newProps.value
      : newProps.value && newProps.value[this.props.currentLang];

    if (
      !this.state.editing &&
      this.state.currentValue !== newValue &&
      newValue
    ) {
      this.setState({ currentValue: newValue });
    }
  }

  setEditing(value) {
    this.setState({ editing: value });
  }

  onInputChange(e) {
    this.setState({ currentValue: e.target.value });
  }

  onLangChange(e) {
    const oldValue = this.props.value;
    const newValue =
      oldValue === Object(oldValue) ? oldValue[e.target.value] : oldValue;
    this.setState({ currentLang: e.target.value, currentValue: newValue });
  }

  save() {
    const { value, finishEdit, noLang } = this.props;
    let currentValue = {};

    if (value === this.state.currentValue) return;
    if (!noLang) {
      if (value === Object(value)) currentValue = value;
      currentValue[this.state.currentLang] = this.state.currentValue;
    } else {
      currentValue = this.state.currentValue;
    }

    this.setEditing(false);
    finishEdit(currentValue);
  }

  render() {
    const {
      className,
      inputClassName,
      placeholder,
      hideIcon,
      noLang,
      disabled,
      style,
    } = this.props;
    const { editing, currentValue, currentLang } = this.state;

    return (
      <div
        className={`form-inline editable-text ${
          editing ? 'editing' : ''
        } ${className}`}
      >
        {!noLang && (
          <>
            <select
              className="form-control"
              onChange={this.onLangChange}
              value={currentLang}
            >
              {langs.map(l => (
                <option value={l} key={`lang_${l}`}>
                  {' '}
                  {l}{' '}
                </option>
              ))}
            </select>
            &nbsp;
          </>
        )}
        <input
          disabled={disabled}
          type="text"
          className={inputClassName}
          style={style}
          spellCheck={false}
          autoComplete="off"
          value={currentValue}
          placeholder={placeholder}
          onChange={this.onInputChange}
          onFocus={() => {
            this.setEditing(true);
          }}
          onBlur={() => {
            this.save();
          }}
          onKeyPress={e => {
            if (e.charCode === 13) {
              this.save();
            }
          }}
        />
        {!hideIcon ? <i className="fa fa-edit" /> : ''}
      </div>
    );
  }
}

EditableText.propTypes = {
  finishEdit: PropTypes.func,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  hideIcon: PropTypes.bool,
  noLang: PropTypes.bool,
};

EditableText.defaultProps = {
  finishEdit: () => {},
  className: '',
  placeholder: '',
};

export default EditableText;
